module.exports = __webpack_public_path__ + "static/media/report-light.d8105728.svg";